import { useEffect } from 'react';

export const usePageTitle = (title: string, withPostfix = true) => {
	useEffect(() => {
		document.title = `${title}${withPostfix ? ' | k+ portál VŠB-TUO' : ''}`;
	}, [title, withPostfix]);
};
